import { Typography } from "antd";
import styled from "styled-components";
import { LoadingOutlined } from "@ant-design/icons";

const Container = styled.div`
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  position: fixed;
  display: flex;
  row-gap: 16px;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #fffb;
  z-index: 99999;
  h3 {
    text-align: center;
    margin: 0 !important;
  }
  .anticon.anticon-loading.anticon-spin {
    width: 48px;
    height: 48px;
    svg {
      width: 48px;
      height: 48px;
      fill: var(--ant-primary-color);
    }
  }
`;

export const LoadingIntegration: React.FC = () => {
  return (
    <Container>
      <LoadingOutlined />
      <Typography.Title level={3}>
        A integração está em andamento.
      </Typography.Title>
      <Typography.Title level={3}>Aguarde!</Typography.Title>
    </Container>
  );
};
